const homeVideo = {
    'button' : document.querySelectorAll('[js-home-video-button]'),
    'popin' : document.querySelector('[js-home-video-popin]'),
};

homeVideo.button.forEach(function(toggle){
    toggle.addEventListener('click', function(e){
        e.preventDefault();
        if(homeVideo.popin.classList.contains('opened')) {
            homeVideo.popin.classList.remove('opened');
            setTimeout(function(){
                homeVideo.popin.classList.add('hidden');
            }, 300);
        }
        else {
            homeVideo.popin.classList.remove('hidden');
            setTimeout(function(){
                homeVideo.popin.classList.add('opened');
            }, 300);
        }
    });
});
